import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Row, Col, Button } from "react-bootstrap";
import RangeCredit from "components/Game/Addons";
import { gameCoin } from "actions/gameCoin";
import { setWallet } from "actions/gameWallet";
import storage from "utils/Storage";
import C from 'utils/Constant';
import { Event, __, isValidNumber, wait, forceSatoshiFormat, sendNotfication, isMobile } from 'utils/Helper';
import { IoAlertCircleOutline } from "react-icons/io5";

class Bet extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      engine: this.props.engine,
      mobile: false,
      isLogged: storage.getKey("logged") !== null ? true : false,
      amount: forceSatoshiFormat(
        storage.getKey("lam") ? storage.getKey("lam") : 50.00
      ),
      inputDisabled: false,
      InsuranceDisabled: true,
      splitDisabled: true,
      hitDisabled: true,
      standDisabled: true,
      doubleDisabled: true,
      buttonText: "Deal",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleBet = this.handleBet.bind(this);
  }

  componentWillUnmount() {
    let { engine } = this.state;
    engine.init = false;
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    let { engine } = this.state;

    this.props.gameCoin();
    engine.on(C.PLAY_BLACKJACK, (data) => this.play(data));
    engine.on(C.BUSTED_BLACKJACK, () => this.busted());
    engine.on(C.ERROR_BLACKJACK, (data) => this.error(data));
    engine.on("stop_playing", () => this.stopManual());

    this.winAmount(this.state.amount);

    if (isMobile()) {
      this.setState({ mobile: true });
    }
  }

  stopManual() {
    this.setState({ buttonText: "Deal", inputDisabled: false });
  }

  play(data) {
    if (this._isMounted) {
      this.setState({ inputDisabled: true });
    }
  }

  busted() {
    if (this._isMounted) {
      wait(2000).then(() => {
        this.setState({ inputDisabled: false });
      });
    }
  }

  placeBet() {
    if (this._isMounted) {
      let { amount, engine } = this.state;

      wait(100).then(() => {
        engine.init = true;
        engine.amount = amount;
        engine.coin = this.props.coin;
        engine.start();
      });
    }
  }

  error(data) {
    if (this._isMounted) {
      sendNotfication(data.message, "info", "top-center");

      if (data.code === "credit") this.props.setWallet(true, data.uid);

      this.setState({ inputDisabled: false });
    }
  }

  handleBet(e) {
    e.preventDefault();
    let { isLogged, amount } = this.state;

    // Check User
    if (!isLogged) {
      return Event.emit("showAuthModal", true);
    }

    if (parseFloat(amount) <= 0) {
      this.setState({ amount: forceSatoshiFormat(50.00) });
    } else {
      amount = Math.min(
        parseFloat(storage.getKey("credit")),
        parseFloat(amount)
      );
      this.setState({ amount: forceSatoshiFormat(amount) });
    }

    this.placeBet();
  }

  handleInputChange(event) {
    let target = event.target;
    let value = target.value;
    if (target.name === "amount") {
      this.setState({ amount: value });
      if (!isValidNumber(value)) return;
    }
    if (target.name === "amount") {
      storage.setKey("lam", value);
    } else {
      this.setState({ [target.name]: value });
    }

    this.winAmount(value);
  }

  winAmount = (value) => {
    this.setState({ winAmount: forceSatoshiFormat(value) });
  };

  setAmount = (val) => {
    var am = forceSatoshiFormat(val);
    this.setState({ amount: am });
    storage.setKey("lam", am);
    this.setState({ winAmount: forceSatoshiFormat(am) });
  };

  render() {
    let {
      bet,
      mobile,
      inputDisabled,
      InsuranceDisabled,
      splitDisabled,
      hitDisabled,
      standDisabled,
      doubleDisabled,
    } = this.state;
    return (
      <>
        <form
          className="w-100 bj"
          onSubmit={(e) => {
            e.preventDefault();
            if (this.props.coin === "INR") {
              if (this.state.amount < 20) {
                sendNotfication("Enter valid amount");
              } else {
                this.handleBet(e);
              }
            } else if (this.props.coin === "USDT") {
              if (this.state.amount < 0.5) {
                sendNotfication("Enter valid amount");
              } else {
                this.handleBet(e);
              }
            } else {
              this.handleBet(e);
            }
          }}
        >
          <Row className="mt-2">
            <Col md={12}>
              <div className="crash-bet-input-label">
                <div className="crash-bet-input-label-left">
                  <div>Amount</div>
                  <div style={{ paddingLeft: "5px" }}>
                    <IoAlertCircleOutline color="#56CF17" size={"17px"} />
                  </div>
                </div>
                
              </div>
              <div className={"form-group mb-1 bet-input"}>
                <div className="input-group">
                  <div className="input-group-append">
                    <span className="input-group-text crash-game-bet-game">
                      <img
                        src={"/assets/images/" + this.props.coin + ".png"}
                        className={"mini-coin-7"}
                        alt=""
                      />
                      {/* BET */}
                    </span>
                  </div>
                  <input
                    style={{ background: "#222328", paddingLeft: "0px" }}
                    disabled={inputDisabled}
                    type="text"
                    className="form-control text-left"
                    id="amount"
                    name="amount"
                    placeholder="Enter Bet Amount"
                    value={this.state.amount}
                    autoComplete={"off"}
                    onKeyUp={this.handleInputChange}
                    onChange={this.handleInputChange}
                  />
                  <div className="input-group-append">
                    <RangeCredit set={this.setAmount} />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={12}>
              <div className="crash-bet-input-label">
                <div className="crash-bet-input-label-left">
                  <div>WIN AMOUNT</div>
                </div>
              </div>
              <div className={"form-group mb-1 bet-input"}>
                <div className="input-group">
                  <div className="input-group-append">
                    <span className="input-group-text crash-game-bet-game">
                      <img
                        src={"/assets/images/" + this.props.coin + ".png"}
                        className={"mini-coin-7"}
                        alt=""
                      />
                      {/* WIN AMOUNT */}
                    </span>
                  </div>
                  <input
                    style={{ background: "#222328", paddingLeft: "0px" }}
                    disabled={true}
                    type="text"
                    className="form-control text-left"
                    placeholder=".."
                    value={this.state.amount}
                    autoComplete={"off"}
                  />
                  <div className="input-group-append">
                    <button
                      style={{
                        background: "#222328",
                        color: "green",
                        borderTopRightRadius: "20px",
                        borderBottomRightRadius: "20px",
                      }}
                      className="btn bg-cs2 after-text no-hover npt nh"
                      type="button"
                    >
                      <i className="mdi mdi-close" />
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: "20px" }}>
            <Row className="col-md-12 hilo-higher-and-lower-button">
              <Col style={{ padding: "5px" }} md={6}>
                <Button
                  className="hilo-higher-button start-auto-bet-mode-button"
                  style={{
                    background: "#6B7180",
                    fontWeight: "500",
                    borderRadius: "20px",
                    fontSize: "12px",
                  }}
                  variant={"btn btn-md btn-block mt-2 btn-hilo"}
                  disabled={hitDisabled}
                  id="hit"
                  type="button"
                >
                  Hit
                </Button>
              </Col>
              <Col style={{ padding: "5px" }} md={6}>
                <Button
                  className="hilo-higher-button start-auto-bet-mode-button"
                  style={{
                    background: "#6B7180",
                    fontWeight: "500",
                    borderRadius: "20px",
                  }}
                  variant={"btn btn-md btn-block mt-2 btn-hilo"}
                  disabled={standDisabled}
                  id="stand"
                  type="button"
                >
                  Stand
                </Button>
              </Col>
            </Row>

            <Row className="col-md-12 hilo-higher-and-lower-button">
              <Col style={{ padding: "5px" }} md={6}>
                <Button
                  className="hilo-higher-button start-auto-bet-mode-button"
                  style={{
                    background: "#6B7180",
                    fontWeight: "500",
                    borderRadius: "20px",
                  }}
                  variant={"btn btn-md btn-block  btn-hilo"}
                  disabled={doubleDisabled}
                  id="double"
                  type="button"
                >
                  Double Down
                </Button>
              </Col>
              <Col style={{ padding: "5px" }} md={6}>
                <Button
                  className="hilo-higher-button start-auto-bet-mode-button"
                  style={{
                    background: "#6B7180",
                    fontWeight: "500",
                    borderRadius: "20px",
                  }}
                  variant={"btn btn-md btn-block   btn-hilo"}
                  disabled={splitDisabled}
                  id="split"
                  type="button"
                >
                  Split
                </Button>
              </Col>
            </Row>

            <Col md={8} className={mobile ? "col-12" : "col-4"}>
              <Button
                className="hilo-higher-button start-auto-bet-mode-button"
                style={{
                  background: "#6B7180",
                  fontWeight: "500",
                  borderRadius: "20px",
                  fontSize: "12px",
                }}
                variant={"btn btn-md btn-block  btn-hilo"}
                disabled={InsuranceDisabled}
                id="insurance"
                type="button"
              >
                Insurance
              </Button>
            </Col>

            <Col style={{ marginBottom: "10px" }} md={12}>
              <Button
                className="start-auto-bet-mode-button"
                style={{
                  // border: "2px solid red",
                  color: "#fff",
                  boxShadow:
                    "0px 0px 12px rgba(35, 238, 136, 0.3), 0px -2px rgb(29, 202, 106) inset",

                  // backgroundColor: "rgb(67, 179, 9)",
                  backgroundImage:
                    "linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113))",
                  borderRadius: "10px",
                }}
                variant={"btn btn-md btn-block my-1 btn-bet"}
                disabled={inputDisabled}
                id="deal"
                type="submit"
              >
                {this.state.buttonText}
              </Button>
            </Col>
          </Row>

          {/* <div>
              <span style={{fontSize:11,marginLeft:5}}>
                {this.props.coin ==='INR' ?
              "(Minimum Bet - 20 INR)"
              :
              "(Minimum Bet - 0.5 USDT)"
              }
              </span>
              </div> */}
        </form>
      </>
    );
  }
}

Bet.propTypes = {
  coin: PropTypes.string,
  credit: PropTypes.string,
};

const mapStateToProps = (state) => ({
  coin: state.items.coin,
  credit: state.items.credit,
});

export default connect(mapStateToProps, { gameCoin, setWallet })(Bet);
